import React from "react";
import EmailField from "../fields/EmailField";
import PasswordField from "../fields/PasswordField";
import { apiLogin } from "../../api/api";

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            loginFailed: false,
            invalidEmail: false,
            loginFailedDescription: '',
        };

        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleLoginSubmit = this.handleLoginSubmit.bind(this);
    }

    handleChangeEmail(event) {
        this.setState({
            ...this.state,
            email: event.target.value,
        });
    }

    handleChangePassword(event) {
        this.setState({
            ...this.state,
            password: event.target.value,
        });
    }

    handleLoginSubmit(event) {
        event.preventDefault();
        if (this.inputValid()) {
            const loginResult = apiLogin(this.state.email, this.state.password);

            loginResult
            .then(res => {
                res.json().then(data => {
                    if (res.ok) {
                        localStorage.setItem('access_token', res.headers.get('AccessToken'));
                        window.location.href = '/landing';
                    } else if (res.status === 403) {
                        if (data.description) {
                            this.setState({
                                ...this.state,
                                loginFailed: true,
                                loginFailedDescription: data.description,
                            });
                        }
                    } else {
                        this.setState({
                            ...this.state,
                            loginFailed: true,
                        });
                    }
                });
            });
        }
    }

    inputValid() {
        if (
            this.state.email !== '' &&
            this.state.password !== ''
        ) {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)) {
                this.setState({
                    ...this.state,
                    invalidEmail: true,
                });
                return false;
            }
            return true;
        }
        return false;
    }

    render() {
        return (
            <div>
                <form onSubmit={this.handleLoginSubmit}>
                    <EmailField value={this.state.email} onChange={this.handleChangeEmail} />
                    <PasswordField value={this.state.password} onChange={this.handleChangePassword} />
                    <input type="submit" value="Submit" />
                    {this.state.loginFailed && !this.state.loginFailedDescription ? (
                        <div className="error">Login failed, please check your email and password and try again, or create an account.</div>
                    ) : (
                        <span />
                    )}
                    {this.state.loginFailedDescription ? (
                        <div className="error">{this.state.loginFailedDescription}</div>
                    ) : (
                        <span />
                    )}
                    {this.state.invalidEmail ? (
                        <div className="error">Invalid email format, please check your email and try again.</div>
                    ) : (
                        <span />
                    )}
                </form>
            </div>
        )
    }
}

export default LoginForm;
